<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn>

    <p class="text-center">
      <b>{{ programa.nombre_compuesto }} </b>
    </p> 
    <p class="text-center">
      <b> Nuevo plan para nuevo Q </b>
    </p> 
    <div class="row justify-center">
      <div class="col col-sm-5 col-lg-4">
        <label class="typo__label text-primary" for="ajax">Buscar Estudiante:</label>
        <multiselect
          class="form-control"
          v-model.trim="estudiante"
          id="id"
          label="nombre"
          track-by="id"
          placeholder="Ingrese el Nombre o documento (4 letras minimo)..."
          open-direction="bottom"
          :options="estudiantes"
          :multiple="false"
          :searchable="true"
          :loading="loading_find"
          :internal-search="false"
          :clear-on-select="true"
          :close-on-select="true"
          :options-limit="300"
          :limit="15"
          :max-height="600"
          :show-no-results="true"
          :hide-selected="true"
          :show-labels="false"
          @search-change="buscar_personas">
          <template slot="clear" slot-scope="props">
            <div
              class="multiselect__clear"
              v-if="estudiante == null"
              @mousedown.prevent.stop="clearAll(props.search)"></div>
          </template>
          <span slot="noResult">Estudiante no encontrado</span>
        </multiselect>
      </div>
    </div>

    <div class="row justify-center">
      <div class="col col-sm-5 col-lg-4">
        <v-select
          v-model="promo"
          :items="promociones"
          :loading="loading_promos"
          item-text="nombre"
          item-value="id"
          label="Seleccione la promocion"
          class="mt-1"
          dense
          outlined
          placeholder="Seleccione...."
          clearable
          return-object />
        <div v-if="promo && promo.id">
          <p class="my-0">{{ promo.descripcion }}</p>
          <p class="my-0">desde: {{ promo.fecha_inicio }}</p>
          <p class="my-0">hasta: {{ promo.fecha_fin }}</p>
          <p class="my-0">aprobado por: {{ promo.aprobado_por }}</p>
          <ul>
            <li v-for="(d, ind) in promo.detalle_promocion" :key="ind">
              {{ d.nombre_concepto }}: {{ d.valor_descuento }} {{ d.is_porcentaje ? '%' : '$' }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row justify-center">
      <div class="col col-sm-5 col-lg-4" style="padding-bottom: 0 !important">
        <v-select
          v-model="plan_seleccionado"
          :items="programa.planes"
          :loading="loading_programa"
          item-text="nombre"
          item-value="plan_cobro_programa_id"
          label="Seleccione el plan"
          class="mt-1"
          hide-details
          dense
          outlined
          placeholder="Seleccione...."
          return-object />
      </div>
      <div class="col col-sm-12" style="padding: 0 !important; margin: 0 !important"></div>
      <div class="col col-sm-5 col-lg-4 col-sm-offset-4" style="padding-top: 0 !important">
        <ul v-if="plan_seleccionado">
          <li v-for="(p, ind) in plan_seleccionado.cobros" :key="ind">
            <b>{{ p.nombre }}:</b> ${{ p.monto }}, max cuotas: {{ p.cuotas }}
          </li>
          <hr class="my-0" />
          <li>Monto de materias: $ {{ monto_por_materias }}</li>
        </ul>
      </div>
      <div class="col col-sm-5 col-lg-4" style="padding-top: 0 !important">
        <div v-if="loading_q10">
          <v-progress-linear indeterminate color="yellow darken-2" />
          <small>Obteniendo deuda del q10...</small>
        </div>
        <div v-if="deuda_q10 && deuda_q10.Numero_cuotas">
          <small class="orange--text">Datos obtenidos del q10:</small>
          <p class="my-0"><b>Valor_credito:</b> $ {{ deuda_q10.Valor_credito }}</p>
          <p class="my-0"><b>Cuotas_pagadas:</b> {{ deuda_q10.Cuotas_pagadas }} de {{ deuda_q10.Numero_cuotas }}</p>
          <p class="my-0"><b>Total_pendiente:</b> $ {{ deuda_q10.Total_pendiente }}</p>
          <v-btn class="white--text" small color="orange" @click="ver_plan_del_q10()">ver creditos q10</v-btn>
          <v-checkbox class="my-0" v-model="incluir_deuda_q10" label="Incluir en el plan"></v-checkbox>
          <!-- <v-checkbox class="my-0" v-model="incluir_deuda_q10_in_plan" label="Test unir con el plan pagos"></v-checkbox> -->
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col col-sm-4 col-lg-4 col-sm-offset-2 col-lg-offset-4">
        <div class="row mb-1">
          <div class="col-xs-6">
            <v-text-field
              label="numero de cuotas"
              placeholder="cantidad..."
              hide-details
              outlined
              dense
              type="number"
              v-model.number="numero_cuotas_total" />
          </div>
          <div class="col-xs-6">
            <v-text-field
              label="cantidad de materias:"
              placeholder="materias..."
              hide-details
              outlined
              dense
              type="number"
              v-model.number="numero_materias_total" />
          </div>
          <div class="col-xs-12 mt-4">
            <v-text-field
              label="Obervaciones:"
              placeholder="materias..."
              hide-details
              outlined
              dense
              type="text"
              v-model="observaciones" />
          </div>
          <div class="col-xs-12 mt-4">
            <v-text-field
              label="Detalle del motivo:"
              placeholder="Descripcion del motivo..."
              hide-details
              outlined
              dense
              type="text"
              v-model="motivo_detalle" />
          </div>
          <div class="col-xs-12 mt-4">
            <v-select
              v-model="q_seleccionado"
              :items="q_items"
              item-text="text"
              item-value="value"
              label="Cuatrimestre (Q)"
              hide-details
              dense
              outlined
              placeholder="Seleccione..." />
          </div>
        </div>

        <p class="my-0"><b>Monto total:</b> $ {{ generado.monto_total }}</p>
        <p class="my-0"><b>Por cuota:</b> $ {{ generado.submonto_base }}</p>
        <v-btn class="white--text" color="green" :disabled="sinplan_seleccionado" @click="generar_plan_pagos()"
          >Generar plan de pagos</v-btn
        >
      </div>

      <div class="col col-sm-4 col-lg-2" v-if="generado && generado.plan_con_descuentos">
        <b class="blue--text">Plan aplicando la promocion:</b>
        <ul>
          <li v-for="(p, ind) in generado.plan_con_descuentos" :key="ind">
            <b>{{ p.nombre }}:</b> {{ p.monto }} (<small> {{ p.promo_descuento }} </small>)
          </li>
        </ul>
      </div>
    </div>

    <div class="row justify-center">
      <div class="col col-sm-8 col-md-6" v-if="generado && generado.plan">
        <p class="my-1 pl-4 green white--text">
          <b>Plan de pagos:</b>
        </p>
        <v-data-table
          :headers="headers"
          xitems="generado.plan"
          :items="planConGrupos"
          :items-per-page="150"
          item-key="index"
          hide-default-footer
          class="elevation-1 tabla-pagos"
          :item-class="rowClass">
          <template v-slot:item.monto="{ item }">
            <span>$ {{ item.monto }} </span>
          </template>
        </v-data-table>
      </div>
    </div>

    <div class="row my-14">
      <div class="col col-sm-3 col-lg-2 col-sm-offset-2 col-lg-offset-4">
        <v-btn
          class="white--text"
          color="orange"
          :loading="loading_cambio"
          :disabled="sinplan_generado"
          @click="registrar_nuevo_q()">
          {{ is_cambio_plan ? 'Cambiar de plan' : 'Registrar nuevo plan' }}
        </v-btn>
      </div>
    </div>

    <confirmarModal ref="refconfirmarModal" />
    <ver_plan_q10 ref="refver_plan_q10" />
  </div>
</template>

<style>
  .tabla-pagos thead th {
    background-color: #4caf50;
    color: #eceff1 !important;
  }

  .grupo-par {
    background-color: #fcfcfc;
  }

  .grupo-impar {
    background-color: #f0f8e8;
  }

  .grupo-q10 {
    background-color: #f6e8f8;
  }
</style>

<script>
  import confirmarModal from './confirmar-modal.vue';
  import ver_plan_q10 from './ver_plan_q10.vue';
  import { get_deuda_q10 } from './q10';
  import {
    buscar_persona,
    getprograma,
    generar_plan,
    headers,
    getpromociones,
    cambiar_a_inscrito,
    planConGruposComputed,
    rowClassX,
    // generar_plan_antes,
    generar_plan_bloque,
    id_concepto_cuota,
    body_cambio_plan,
  } from './utils';

  export default {
    components: { confirmarModal, ver_plan_q10 },
    data() {
      return {
        loading_find: false,
        loading_programa: false,
        loading_promos: false,
        loading_q10: false,
        loading_cambio: false,
        incluir_deuda_q10: true,
        incluir_deuda_q10_in_plan: false,
        promociones: [],
        promo: {},
        estudiantes: [],
        estudiante: {},
        programa: { planes: [] },
        numero_cuotas_total: 0,
        numero_materias_total: 1,
        plan_seleccionado: null,
        headers: headers,
        generado: {},
        inscripcion_id: '',
        is_cambio_plan: false,
        asesor_id: '',
        is_new_inscripcion: false,
        observaciones: 'Segundo plan - cuotas adicionales por módulo extra',
        motivo_detalle: 'Módulo optativo extra',
        q_seleccionado: null,
        q_items: [
          { text: 'Q1', value: 0 },
          { text: 'Q2', value: 4 },
          { text: 'Q3', value: 8 },
        ],
        deuda_q10: {},
      };
    },
    watch: {},
    computed: {
      sinplan_seleccionado() {
        if (this.plan_seleccionado && this.plan_seleccionado.cobros && this.numero_cuotas_total > 0 && this.q_seleccionado !== null) {
          return false;
        }
        return true;
      },
      sinplan_generado() {
        if (this.generado && this.generado.plan) {
          return false;
        }
        return true;
      },
      planConGrupos() {
        return planConGruposComputed(this.generado.plan);
      },
      monto_por_materias() {
        const cuo = this.plan_seleccionado.cobros.find((x) => x.concepto_id == id_concepto_cuota);
        if (cuo) return cuo.monto * this.numero_materias_total;
        return 0;
      },
    },
    methods: {
      rowClass(item) {
        return rowClassX(item, this.incluir_deuda_q10_in_plan);
      },
      async buscar_personas(e) {
        this.loading_find = true;
        const res = await buscar_persona(this, e);
        this.loading_find = false;
        this.estudiantes = res;
        if (res && res.length == 1) {
          this.estudiante = res[0];
        }
      },
      async getprogramadata() {
        this.inscripcion_id = parseInt(this.$route.query.ins_id);
        this.asesor_id = parseInt(this.$route.query.asesor_id);
        this.is_cambio_plan = this.$route.query.cambio_plan == 'true'
        this.is_new_inscripcion = this.$route.query.inscribir == 'true';
        const doc = this.$route.query.doc;

        this.loading_programa = true;
        const res = await getprograma(this.$route.params.idprograma);
        this.loading_programa = false;
        res.planes.forEach((x) => {
          x.cobros.forEach((c) => {
            if (c.monto == 1) c.monto = 0;
          });
        });
        this.programa = res;
        this.programa.planes = res.planes.filter((x) => x.estado);

        this.buscar_personas(doc);
        this.get_deuda(doc);
      },
      async getpromos() {
        this.loading_promos = true;
        const res = await getpromociones(this.$route.params.idprograma);
        this.loading_promos = false;
        if (res && res.data) {
          this.promociones = res.data;
          if (res.data.length == 1) this.promo = res.data[0];
        }
      },
      async get_deuda(doc) {
        this.loading_q10 = true;
        this.deuda_q10 = {};
        const res = await get_deuda_q10(doc);
        this.loading_q10 = false;
        this.deuda_q10 = res;
        window.console.log('deuda:::res', res);
      },

      generar_plan_pagos() {
        const cobros = JSON.parse(JSON.stringify(this.plan_seleccionado.cobros));
        const deuda = this.incluir_deuda_q10 ? this.deuda_q10 : null;
        const inp = {
          numero_cuotas_total: this.numero_cuotas_total,
          numero_materias_total: this.numero_materias_total,
          plan_seleccionado: this.plan_seleccionado,
        };
        /* if (this.incluir_deuda_q10_in_plan) {
          const res = generar_plan_antes(inp, this.promo, cobros, deuda);
          this.generado = {};
          this.generado = res;
        } else  */
        if (this.plan_seleccionado.nombre.includes('BLOQUE ')) {
          const res = generar_plan_bloque(inp, this.promo, cobros, deuda, this, this.q_seleccionado);
          this.generado = {};
          this.generado = res;
        } else {
          const res = generar_plan(inp, this.promo, cobros, deuda, this.q_seleccionado);
          this.generado = {};
          this.generado = res;
        } 
      },

      async ver_plan_del_q10() {
        const res = await this.$refs.refver_plan_q10.openmodal(this.deuda_q10);
        window.console.log('>>>', res);
      },

      async realizar_cambio() {
        const aceptar = await this.$refs.refconfirmarModal.openmodal();
        if (!aceptar) return;

        if(this.is_cambio_plan){
          return this.cambio_de_plan();
        }

        this.loading_cambio = true;
        const yo = this.$store.state.DATA_USER;
        const extras = {
          inscripcion_id: this.inscripcion_id,
          asesor_id: this.asesor_id,
        };
        const res = await cambiar_a_inscrito(
          yo,
          this.estudiante,
          this.programa,
          this.plan_seleccionado,
          this.generado.plan,
          extras,
        );
        this.loading_cambio = false;
        if (res && res.inscripcion_id) {
          this.$root.$notify.show('inscrito correctamente', {
            color: 'green',
            x: 'right',
          });
          this.$router.back();
        } else {
          this.$root.$notify.show(res.error, {
            timeout: 8000,
            color: 'red',
            x: 'right',
          });
        }
      },

      async registrar_nuevo_q(){
        const aceptar = await this.$refs.refconfirmarModal.openmodal();
        if (!aceptar) return;

        // this.$root.$notify.show('sin comentarios', {color:'red',x: 'right',});
        this.cambio_de_plan();
      },

      async cambio_de_plan(){
        const userid = this.$store.state.DATA_USER.id;
        
        const body = {
          inscripcion_id: this.inscripcion_id,
          programa_id: this.programa.programa_id,
          estudiante_id: this.estudiante.id,
          asesor_id: this.asesor_id,
          registrado_por: userid,
          tipo_pago: true, // true  a cuotas, false al contado
          plan_cobro_programa_id: this.plan_seleccionado.plan_cobro_programa_id,
          plan_pagos: this.generado.plan,
          observaciones: this.observaciones,
          motivo: this.is_new_inscripcion? 'inicial':'adicional',
          motivo_detalle: this.motivo_detalle,
          inscribir: this.is_new_inscripcion,
        };
        if(this.promo && this.promo.id){
          body.promocion_id = this.promo.id
        }
        window.console.log('body:::',body, this.promo);
        window.console.log('body',body);
        
        this.loading_cambio = true;
        const res =await body_cambio_plan(body, false)
        this.loading_cambio = false;
        window.console.log('body generar plan', res);
        if(res && res.result){
          this.$root.$notify.show('Generacion de plan realizado correctamente', {
            color: 'green',
            x: 'right',
          }); 
        } else {
          this.$root.$notify.show(res.error || 'Error al generar plan', {
            timeout: 8000,
            color: 'red',
            x: 'right',
          });
        }
      }
    },
    mounted() {
      this.getprogramadata();
      this.getpromos(); 
    },
  };
</script>
